import Const from 'const';
import {LineupStackExtractor} from './lineup-stack-extractor';

export class NhlLineupStackExtractor extends LineupStackExtractor {
    protected extractStackedTeams(): void {
        const markedItems = this.marker.pickMarkedBySuffix(this.lineup);

        markedItems.map((markedItem) => {
            if (markedItem[0] !== Const.LP_SUBGROUP_PREFIX) {
                return;
            }

            const [teamName] = markedItem.replace(Const.LP_SUBGROUP_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

            this.stackedTeams.push(teamName);
        });
    }
}
